import { render, staticRenderFns } from "./ClipboardIcon.vue?vue&type=template&id=1f719cb5&scoped=true&"
import script from "./ClipboardIcon.vue?vue&type=script&lang=js&"
export * from "./ClipboardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f719cb5",
  null
  
)

export default component.exports